export const loginBundle = {
  forms: [
    { name: "user_id", type: "text", placeholder: { ko: "아이디", en: "ID", es: "ID" } },
    {
      name: "password",
      type: "password",
      placeholder: { ko: "패스워드", en: "Password", es: "Contrasena" }
    }
  ],
  login: { ko: "로그인", en: "LOGIN", es: "INICIAR SESION" },
  message: {
    ko: "아이디 또는 비밀번호가 잘못되었습니다.",
    en: "Invalid ID or password.",
    es: "ID o contrasena incorrectos."
  }
}
